import { Helmet } from "react-helmet-async";

const ContactPage = () => {
  return (
    <>
      <Helmet>
        <title>Contact - Boobalyz</title>
        <meta
          name="description"
          content="Get in touch with the Boobalyz team"
        />
      </Helmet>

      <div className="bg-slate-50 min-h-screen py-16 px-6">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-4xl font-bold text-slate-900 mb-4">Contact Us</h1>
          <p className="text-slate-500 text-lg leading-relaxed mb-8">
            Get in touch with our team for support, questions, or feedback.
          </p>

          <div className="bg-white rounded-xl border border-slate-200 p-8">
            <div className="text-center py-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                We'd Love to Hear From You
              </h2>
              <p className="text-slate-600 mb-8">
                Contact our team using the information below.
              </p>
              <div className="space-y-4 max-w-md mx-auto text-left">
                <p className="text-slate-600">
                  <strong className="text-slate-900">Email:</strong>{" "}
                  support@boobalyz.com
                </p>
                <p className="text-slate-600">
                  <strong className="text-slate-900">Phone:</strong> +1 (555)
                  123-4567
                </p>
                <p className="text-slate-600">
                  <strong className="text-slate-900">Hours:</strong> Monday -
                  Friday, 9 AM - 5 PM EST
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;
